import * as Yup from 'yup';
import { commonDriverLicenseNumberValidation } from '@modules/ContactManager/components/Tabs/components/Contact/validation';
import { isAtLeastOnePhoneProvided } from '@shared/commonFunctions';

const phoneValidationMsg = 'At least one phone number is required';

const addressShape = Yup.object().shape({
  isCurrent: Yup.boolean().nullable(),
  includeInDti: Yup.boolean().nullable(),
  monthsAtAddress: Yup.number().nullable(),
  streetLine1: Yup.string().nullable().max(26, 'Street should be max 26 symbols'),
  streetLine2: Yup.string().nullable().max(48, 'Unit/Apt should be max 48 symbols'),
  city: Yup.string().nullable().max(48, 'City should be max 48 symbols'),
  state: Yup.string().nullable(),
  zip: Yup.string().zipCode().nullable(),
  type: Yup.string().nullable(),
  county: Yup.string().nullable(),
});

const employmentShape = Yup.object().shape({
  monthsAtJob: Yup.number().nullable(),
  jobTitle: Yup.string().nullable().max(26, 'Job Title should be max 26 symbols'),
  employmentType: Yup.string().nullable(),
  companyName: Yup.string().nullable().max(26, 'Company should be max 26 symbols'),
  monthlyIncomeAmount: Yup.number().nullable(),
  isCurrent: Yup.boolean().nullable(),
  isPrimary: Yup.boolean().nullable(),
  streetLine1: Yup.string().nullable().max(48, 'Street should be max 48 symbols'),
  streetLine2: Yup.string().nullable().max(48, 'Unit/Apt should be max 48 symbols'),
  city: Yup.string().nullable().max(48, 'City should be max 48 symbols'),
  state: Yup.string().nullable(),
  zip: Yup.string().zipCode().nullable(),
  type: Yup.string().nullable(),
  county: Yup.string().nullable(),
});

const phoneValidation = Yup.string().phone().nullable()
  .test('at-least-one-phone', phoneValidationMsg, (_, { parent: { homePhone, workPhone, cellPhone }}) => isAtLeastOnePhoneProvided({
    homePhone,
    workPhone,
    cellPhone,
  }),
);

export const contactManagerFormSchema = Yup.object().shape({
  secondarySource: Yup.string().max(128).required(),
  firstName: Yup.string().required().max(128, 'Full Name field should be max 128 symbols'),
  middleInitial: Yup.string().nullable().max(128, 'Middle Name field should be max 128 symbols'),
  lastName: Yup.string().nullable().required().max(128, 'Last Name field should be max 128 symbols'),
  suffix: Yup.string().nullable(),
  maidenName: Yup.string().nullable().max(128, 'Mother\'s Maiden Name field should be max 128 symbols'),
  ssn: Yup.string().matches(/^\d{9}$/, 'SSN must be 9 digits').nullable(),
  dateOfBirth: Yup.date().typeError('DOB is invalid').nullable(),
  homePhone: phoneValidation,
  workPhone: phoneValidation,
  workPhoneExtension: Yup.string().nullable().max(6, 'Phone Ext field should be max 6 numbers'),
  cellPhone: phoneValidation,
  email: Yup.string().required().email().nullable().max(128, 'Email field Address field should be max 128 symbols'),
  militaryStatus: Yup.string().nullable(),
  maritalStatus: Yup.string().nullable(),
  driverLicenseNumber: commonDriverLicenseNumberValidation,
  driverLicenseExpireDate: Yup.string().nullable(),
  driverLicenseIssuesOnDate: Yup.string().nullable(),
  driverLicenseState: Yup.string().nullable(),

  currentAddress: addressShape,
  previousAddress: addressShape,
  currentEmployer: employmentShape,
  previousEmployer: employmentShape,

  asset: Yup.object().shape({
    assetType: Yup.string().nullable(),
    mileage: Yup.string().nullable(),
    vin: Yup.string().nullable(),
    year: Yup.string().nullable(),
    make: Yup.string().nullable(),
    model: Yup.string().nullable(),
    kbbTrim: Yup.string().nullable(),
    nadaTrim: Yup.string().nullable(),
    actualNadaTradeIn: Yup.string().nullable(),
    assetCondition: Yup.string().nullable(),
  }),
});
